import React from "react";
import { Box } from "@mui/material";
import Header from "../shared/header";
import ForgotPasswordForm from "../shared/forms/forgot-password";

/**
 * Forgot Password page component that provides a form for users to request a password reset.
 * The page displays a centered layout with a header and the forgot password form.
 * 
 * @component
 * @returns {JSX.Element} A centered box containing the forgot password UI
 * 
 * @example
 * ```tsx
 * <ForgotPasswordPage />
 * ```
 */
const ForgotPasswordPage = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh" /* Adjust the height as needed */
    >
      <Box width="60%" m="20px">
        <Box textAlign="center">
          <Header
            showLogo
            subtitle="Verwenden Sie E-Mail, um das Passwort zurückzusetzen!"
          />
        </Box>
        <ForgotPasswordForm />
      </Box>
    </Box>
  );
};

export default ForgotPasswordPage;
